import { BASE_URL, MOST_SEARCH_JOBS_DEPARTMENTS, PUBLIC } from "../../common/URLs";

const API_BASE_URL = `${BASE_URL}/${PUBLIC}/${MOST_SEARCH_JOBS_DEPARTMENTS}`;

export const fetchJobCategoryList = async () => {
  try {
    const response = await fetch(API_BASE_URL, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("error", error);
    throw error; // ensure thunk catches it
  }
};
